;(function ($) {
  'use strict';

  $(document).ready(function() {
    mobile_menu();
    search_toggle();
  });

  $(window).on('resize', function() {
    reset_header();
  });

  const $html = $('html');
  const $main_menu = $('.header__main-menu .main-menu');
  const $toggable = $('.header__toggable');
  let $search_toggle = $('.menu-main-search');
  let $mobileMenu = $('.menu-main-toggle');
  let $global_submenus = $main_menu.find('> .menu-item > .menu__submenu');

	// mobile menu toggling
	function mobile_menu() {
    // mobile menu toggle
    $mobileMenu.on('click', function(evt) {
    	evt.preventDefault();
    	evt.stopPropagation();

    	if ( !$(this).hasClass('active') ) {
    		$mobileMenu.addClass('active').attr('aria-label', 'Close the main menu navigation');

    		$toggable.show();

    		setTimeout(function() {
    			$toggable.addClass('active');
    			$html.addClass('menu-is-open').attr('draggable', false);
    		}, 250);
    	}
    	else {        
    		$mobileMenu.removeClass('active').attr('aria-label', 'Open the main menu navigation')

    		$html
    		.removeClass('menu-is-open')
    		.attr('draggable', true);

    		$toggable.removeClass('active');
    		$('.main-menu .submenu--revealed').removeClass('submenu--revealed');

    		setTimeout(function() {
    			$toggable.hide();
    			$global_submenus.removeClass('active').hide();
    		}, 250);
      }
    });
  }

  // reset menu on window resize
  function reset_header() {
    if ( $mobileMenu.css('display') == 'none' ) {
      if ( $('.menu-is-open').length ) {
        $mobileMenu.removeClass('active').attr('aria-label', 'Open the main menu navigation')

        $html
          .removeClass('menu-is-open')
          .attr('draggable', true);

        $toggable.removeClass('active');
        $toggable.css('display','');
        $('.submenu--revealed > .menu__submenu-toggle').trigger('click');
        $('.menu__submenu').css('display','');
      }
      else {
        $toggable.css('display','');
      }
    }
  }

  // search toggle
  function search_toggle() {
    $search_toggle.on('click', function(evt) {
      evt.preventDefault();
      if ( !$(this).hasClass('active') ) {
        $search_toggle.addClass('active');
        $mobileMenu.addClass('active').attr('aria-label', 'Close the main menu navigation');

        $toggable.show();

        setTimeout(function() {
          $toggable.addClass('active');
          $html.addClass('menu-is-open').attr('draggable', false);
        }, 250);

        $('#mobileSearch').show();
        setTimeout(function() {
          $('#mobileSearch').addClass('active');
        }, 10);   
      }
      else {
        $search_toggle.removeClass('active');
        $mobileMenu.removeClass('active').attr('aria-label', 'Open the main menu navigation')

        $html
        .removeClass('menu-is-open')
        .attr('draggable', true);

        $toggable.removeClass('active');
        $('.main-menu .submenu--revealed').removeClass('submenu--revealed');

        $('#mobileSearch').removeClass('active');

        setTimeout(function() {
          $toggable.hide();
          $global_submenus.removeClass('active').hide();
          $('#mobileSearch').hide();
        }, 250);
      }
    });
  }

  // Function to check if the header is overflowing (workaround to fix Google Translate JS making the header go wider and off screen)
  let storedOverflowWidth = null;

function checkHeaderOverflow() {
    const header = document.querySelector('.header__toggable-inner');
    const rect = header.getBoundingClientRect();
    const currentWidth = window.innerWidth;

    // Check if the header overflows the viewport
    if (rect.right > currentWidth) {
        // If it overflows, add the class and store the window width
        if (!header.classList.contains('is-overflowing')) {
            header.classList.add('is-overflowing');
            storedOverflowWidth = currentWidth;
        }
    } else {
        // Only remove the class if the window width is greater than the stored width
        if (storedOverflowWidth === null || currentWidth > storedOverflowWidth) {
            header.classList.remove('is-overflowing');
        }
    }
}

// Listen for window resize events to recheck if the header is overflowing
window.addEventListener('resize', checkHeaderOverflow);

// Monitor content changes in the div with MutationObserver to detect translation changes
const observer = new MutationObserver(() => {
    checkHeaderOverflow();
});

// Configure the observer for the navigation div
const targetNode = document.querySelector('.header__toggable-inner');
if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
}

// Run the check function on page load with a delay
setTimeout(function() {
    checkHeaderOverflow();
}, 1000);

  

})(jQuery);